import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const FAQCta = () => {
  return (
    <section className="py-12 md:py-20 bg-[#F8F6F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-[#0A1628] rounded-3xl px-6 md:px-10 py-10 md:py-16 flex flex-col lg:flex-row items-center justify-between gap-8 md:gap-10"
        >
          <div className="text-center lg:text-left max-w-2xl">
            <div className="inline-flex items-center gap-2 bg-[#D4AF37]/20 border border-[#D4AF37]/30 text-[#D4AF37] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-[10px] md:text-xs font-bold tracking-wider mb-4 md:mb-6">
              <i className="ri-shield-check-line text-xs md:text-sm"></i>
              REGULARIZE SUA EMPRESA
            </div>
            <h2 className="font-display font-bold text-2xl md:text-3xl lg:text-4xl text-white leading-tight mb-3 md:mb-4">
              Ainda tem dúvidas? Fale com um engenheiro especialista
            </h2>
            <p className="text-neutral-400 text-sm md:text-base leading-relaxed">
              Nossa equipe técnica está pronta para avaliar a situação da sua empresa e indicar o melhor caminho para regularização e conformidade.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 flex-shrink-0 w-full sm:w-auto">
            <a
              href={`https://wa.me/5515996719308?text=${encodeURIComponent('Olá! Vim pela página de Perguntas Frequentes (FAQ) e ainda tenho dúvidas sobre regularização. Pode me ajudar?')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-[#25D366] text-white px-5 md:px-7 py-3 md:py-4 rounded-md text-xs md:text-sm font-bold hover:bg-[#1ebe5d] transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-base md:text-lg"></i>
              FALAR NO WHATSAPP
            </a>
            <a
              href={`https://wa.me/5515996719308?text=${encodeURIComponent('Olá! Vim pela página de Perguntas Frequentes (FAQ) e gostaria de solicitar um orçamento.')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-[#D4AF37] text-[#0A1628] px-5 md:px-7 py-3 md:py-4 rounded-md text-xs md:text-sm font-bold hover:bg-[#C4A137] transition-all whitespace-nowrap cursor-pointer"
            >
              SOLICITAR ORÇAMENTO
              <i className="ri-arrow-right-line text-base md:text-lg"></i>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQCta;